import Rest from '../Rest'

export default class InfluencerGroupService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/influencer_groups'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  saveMembers(id: number, influencerIds: number[]) {
    return this.put(`/${id}/members`, { influencer_ids: influencerIds })
  }
}
